<template name="dialog-confirm">
	<div class="choose-media">
		<el-dialog
		  title="素材库导入"
		  :visible.sync="show"
		  :before-close="close"
		  :close-on-click-modal="false"
		>
			<div>
				<div v-if="category_id == 0 && list.length <= 0" class="media-empty-box">
					<div>
						<img src="../../assets/img/promotion/ztd_empty.png">
						<div>没有可导入的素材，您可前往素材库添加</div>
					</div>
				</div>
				
				<div v-else class="media-wrap">
					<div class="media-nav-box">
						<el-tree
							ref="treeSelect"
							node-key="value"
							:data="category" 
							:props="defaultProps" 
							:default-expanded-keys="defaultShowKey"
							@node-click="handleNodeClick" 
							highlight-current>
						</el-tree>
					</div>
					<div class="media-item-box">
						
						<div v-if="list.length <= 0" class="media-empty-box">
							<div>
								<img src="../../assets/img/promotion/ztd_empty.png">
								<div>当前分组没有可选择的素材</div>
								<div>您可前往素材库添加</div>
							</div>
						</div>
						
						<el-checkbox-group v-else class="media-check" v-model="checks">
							<div class="media-item"  v-for="item in list">
								<el-checkbox :label="item.id">
									<img style="width: 80px;height: 80px;object-fit: cover;" class="media-cover" :src="item.cover_url" alt="">
								</el-checkbox>
							</div>
						</el-checkbox-group>
						
						<!-- 分页器 -->
						<div class="pager-box" v-if="list.length > 0">
							<el-pagination align='center' @size-change="handleSizeChange"
								@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
								layout="total, prev, pager, next" :pager-count='5' :total="total">
							</el-pagination>
						</div>
					</div>
				</div>
			</div>
			
			<div slot="footer" v-if="!(category_id == 0 && list.length <= 0)" >
				<span class="media-count">已选{{checks.length}}个素材</span>
				<el-button style="width: 96px;" type="primary" @click="confirm" :disabled="disabled">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAllCategory
	} from '@/api/depot_category';
	import {
		getImportList,
		getMediaInfoByIds
	} from '@/api/depot_media';
	export default {
		data() {
			return {
				defaultShowKey: [0],
				currentPage: 0, // 当前页码
				total: 0, // 总条数
				pageSize: 12, // 每页的数据条数
				
				category_id: 0,
				checks: [],
				category: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				list:[],
				disabled: false
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			type: {
				type: Number,
				default: 1
			},
			ids: {
				type: Array,
				default: []
			},
		},
		watch:{
			show: function(newVal, oldVal){
				if(newVal){
					this.checks = this.ids;
					this.getCategory();
				}
			}
		},
		methods: {
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getMedia();
			},
			
			// 点击节点
			handleNodeClick(e){
				if(this.category_id == e.value){
					return;
				}
				this.category_id = e.value;
				
				// 调用接口获取数据
				this.getMedia(true);
			},
			_reset(){
				this.category_id = 0;
				this.category = [];
				this.list = [];
				this.checks = [];
				this.disabled = false;
			},
			close() {
				this.$emit('close');
				this._reset()
			},
			confirm() {
				var checks = this.checks
				if(checks.length <= 0){
					this.$emit('success',[]);
					this._reset()
				}else{
					getMediaInfoByIds({
						type:  this.type,
						ids: JSON.stringify(checks)
					}).then(res => {
						if (res.code == 0) {
							this.$emit('success',res.data);
							this._reset()
						} else {
							this.$message.error(res.message);
						}
					})
				}
			},
			getCategory() {
				var that = this;
				getAllCategory({
					type: this.type
				}).then(res => {
					if (res.code == 0) {
						this.category_id = res.data[0].value;
						this.category = res.data;
						this.getMedia();
						
						setTimeout(function(){
							that.$refs['treeSelect'].setCurrentKey(0)
						},100)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			getMedia(refresh=false) {
				if (refresh) {
					this.currentPage = 0;
				}
				var currentPage = this.currentPage;
				if (currentPage > 0) {
					currentPage = currentPage - 1;
				}
				
				getImportList({
					start: currentPage * this.pageSize,
					limit: this.pageSize,
					type:  this.type,
					category_id: this.category_id
				}).then(res => {
					if (res.code == 0) {
						this.total = res.data.allcount;
						this.list = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				})
			},
		},
		mounted() {
		}
	}
</script>

<style>
	
	.choose-media .el-dialog__body {
		padding-top: 0;
		padding-bottom: 16px;
	}
	.choose-media .el-dialog {
		width: 600px;
	}
	.choose-media .el-dialog__footer {
		padding-top: 0;
		padding-bottom: 16px;
	}
	
	
	.media-empty-box {
		margin: 0 auto;
		min-height: 340px;
		text-align: center;
		font-size: 12px;
		font-family: PingFangSC-Medium, PingFang SC;
		color: #999999;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.media-empty-box img{
		width: 126px;
		display: block;
		margin: 0 auto 10px auto;
	}
	
	
	.media-wrap{
		display: flex;
		min-height: 340px;
	}
	
	.media-nav-box{
		width: 200px;
		max-height: 340px;
		border-right: 1px solid #EEEEEE;
		box-sizing: border-box;
		overflow-x: auto;
		overflow-y: auto;
	}
	.choose-media .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
		background-color: transparent;
		color: #1989FA;
		border-radius: 2px;
	}
	.choose-media  .el-tree-node__label{
		padding-right: 10px;
	}
	.choose-media  .el-tree-node__content{
		padding: 4px 0;
	}
	.choose-media .el-tree-node>.el-tree-node__children{
		overflow: inherit;
	}
	
	.media-item-box{
		width: 400px;
	}
	.media-check{
		display: flex;
		flex-wrap: wrap;
		height: 270px;
	}
	.choose-media .el-checkbox__label{
		padding: 0;
	}
	.choose-media .el-checkbox__input{
		position: absolute;
		top: 5px;
		left: 5px;
	}
	.media-item{
		width: 80px;
		height: 80px;
		border-radius: 4px;
		margin:0 0 10px 10px;
	}
	.media-cover{
		background: #000;			
		/* width: 80px;
		height: 80px;
		border-radius: 4px; */
	}
	.choose-media .pager-box{
		padding-top: 34px;
	}
	
	.media-count{
		font-size: 12px;
		font-family: AlibabaPuHuiTi_2_65_Medium;
		color: #666666;
		margin-right: 10px
	}
</style>